import { ActionMenu, VerticalFlex } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const ActionMenuStyled = styled(ActionMenu)`
  min-width: initial !important;
`;

export const HeaderContainer = styled(VerticalFlex)`
  margin-top: 28px;
`;
